import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { HBox } from '../../../components/Box';
import { IsOpen } from '../../../components/Icon';
import { Cell, List, Row } from '../../../components/List';
import { selectWorks, selectPermissions } from '../../Api/selectors';

import { getDate } from '../helpers';
import cn from 'classnames';
import styles from './DebitorVehicleCard.module.css';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { hasPermissions } from '../../../utils/helpers/permissions';


const Container = styled.div`
  font-size: 14px;
  width: 100%;
  .cell:first-child {
    text-transform: capitalize;
  }

  .list-title {
    padding: 8px 0;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
  }
`;

const STATE = {
  isOpen: false,  
};  
  
 
/* eslint-disable react/prefer-stateless-function */
class DebitorVehicleCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (hasPermissions(this.props.permissions, DEP_COMMERCE || DEP_ADMINISTRATION || DEP_FINANCE || DEP_WALSTREET || DEP_WORKSHOP || DEP_ADMIN )) {
      this.setState({ isOpen: true });
    }
  }

  render() {
    const vehicle = this.props.vehicle;
    return (
      <Container>
        <Card className={cn('vehicle-info-card info-card data', styles.card)}>
          <HBox>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.data.assignment_of_debitor')}</h2>
       
              <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
          
          </HBox>
          {(this.state.isOpen) && (
            <List>
              {[
                'sold',
                'rdw_tenaamstelling_date_seller',
                'rdw_tenaamstelling_date_seller_sold',
                'rdw_tenaamstelling_date_seller_counter',
              ].map(property => {
                if (property === 'rdw_tenaamstelling_date_seller' || property === 'rdw_tenaamstelling_date_seller_sold') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="text-nowrap">{getDate(vehicle[property])}</Cell>
                    </Row>
                  );
                }

                if (property === 'sold') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="text-nowrap">
                        <CheckboxComponent checked={vehicle?.rdw_tenaamstelling_date_seller_sold} />
                      </Cell>
                    </Row>
                  );
                }

                return (
                  vehicle[property] && (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="text-nowrap">
                        {vehicle[property] ? `${vehicle[property]} ${this.lblStr('days')}` : ''}
                      </Cell>
                    </Row>
                  )
                );
              })}
            </List>
          )}
        </Card>
      </Container>
    );
  }
}

DebitorVehicleCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
  permissions: selectPermissions(),
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const DebitorVehicleCard = compose(withConnect, withRouter, injectIntl)(DebitorVehicleCardComp);
